import React from 'react';

import { Text } from '@reckon-web/text';

// ActivityCategory SignOffWithdraw = 9
export const ActivityCategorySignOffWithdraw = () => (
  <Text size="small">Withdrew sign off request</Text>
);
